module.exports = __webpack_public_path__ + "static/media/tomahawk-wheels.62c48fe7.jpg";